module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal-popup-black', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.InnerIsShowModal),
      expression: "InnerIsShowModal"
    }],
    attrs: {
      "title": _vm.$t("profile.delete_account.modal.title"),
      "textBtnPrimary": _vm.$t("profile.delete_account.modal.btn_text.primary"),
      "textBtnSecondary": _vm.$t("profile.delete_account.modal.btn_text.secondary")
    },
    on: {
      "eventBybtnPrimary": _vm.modalOk,
      "eventBybtnSecondary": _vm.modalClose,
      "eventBybtnCrissCross": _vm.modalCrissCross
    },
    scopedSlots: _vm._u([{
      key: "content",
      fn: function() {
        return [_c('div', {
          staticClass: "content"
        }, [_c('p', [_vm._v("Ми дуже сумуємо, що ви вирішили видалити свій акаунт. Нагадуємо, що ваш акаунт надає чудові переваги, включаючи:")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Зручне зберігання всіх ваших квитків на одній сторінці.")]), _vm._v(" "), _c('li', [_vm._v("Детальна історія ваших покупок для легкості відстеження витрат.")]), _vm._v(" "), _c('li', [_vm._v("Оперативна підтримка для швидкого розв'язання будь-яких питань.")]), _vm._v(" "), _c('li', [_vm._v("Ексклюзивні акції та спеціальні пропозиції.")]), _vm._v(" "), _c('li', [_vm._v("Швидке бронювання квитків з можливістю зберігання адрес та інших даних.")]), _vm._v(" "), _c('li', [_vm._v("Зручна оплата для спрощення процесу купівлі квитків та послуг.")])]), _vm._v(" "), _c('p', [_vm._v("Ви завжди можете зареєструватися знову, ми чекатимемо на вас!")])])]
      },
      proxy: true
    }])
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0623c210","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/profile-page/impl/delete-account/imlp/modal/index.vue
// module id = 393
// module chunks = 1